<div class="d-flex justify-content-center">
  <img [src]="qrImageSrc" class="qr-image" alt="QR Code">
</div>
